import Component from '../colorz/Component';

export default class FormRegister extends Component {
	onInit(el) {
		this.el = el;
		this.elRequired = this.el.querySelectorAll('[required]');
		this.elBtn = this.el.querySelector('button');
	}

	onReady() {
		if (!this.elRequired.length) return; // if any element is required: return

		this.checkRequired();

		this.elRequired.forEach((element) => {
			element.addEventListener('input', this.checkRequired.bind(this));
		});
	}

	/**
	 * checkRequired
	 * everytime an input is change, check all them
	 */
	checkRequired() {
		this.changeBtnAtt();
		let not_requiered = true;

		for (const element of this.elRequired) {
			if (element.type == 'checkbox') {
				if (!element.checked) not_requiered = false;
			} else if (element.type == 'text' || element.type == 'number') {
				if (element.value == '') not_requiered = false;
			}
		}

		not_requiered && this.changeBtnAtt(true);
	}

	changeBtnAtt(status = false) {
		status
			? this.elBtn.removeAttribute('disabled')
			: this.elBtn.setAttribute('disabled', '');
	}
}
